import { NgModule } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { YellowBranchMapComponent } from './yellow-branch-map.component';
import { AppComponentsSharedModule } from '../app-components.shared.module';

@NgModule({
  imports: [
    JssModule.forChild(YellowBranchMapComponent),
    AppComponentsSharedModule
  ],
  declarations: [
    YellowBranchMapComponent
  ],
  exports: [
    YellowBranchMapComponent,
  ],
})
export class YellowBranchMapModule { }
